import React from 'react';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PropTypes from 'prop-types';
import fr from 'facet-rest';

export const AccountOpeningTrustAddressLayout = ({ resource }) => {
  return (
    <FDContentContainer>
      <PageContentTop
        resource={resource}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <br />
      <MetaControlField attr="trustSitusState" />
      <MetaControlField attr="trustLegalAddressStreetAddressOne" />
      <MetaControlField attr="trustLegalAddressStreetAddressTwo" />
      <FDStack direction={'row'} spacing={1}>
        <MetaControlField attr="trustLegalAddressCity" />
        <MetaControlField attr="trustLegalAddressState" />
      </FDStack>
      <MetaControlField attr="trustLegalAddressPostalCode" />
    </FDContentContainer>
  );
};

AccountOpeningTrustAddressLayout.defaultProps = {
};

AccountOpeningTrustAddressLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
